<template>
  <div class="submenu-container">
    <ul class="submenu-sections">
      <router-link v-if="currentStation.allowTrackUpload" tag="li" :to="{name:'PendingHome', query: $route.query, params: { fileType: 'MUSIC' }}">
        <a>
          <h4><span class="text">Tracks</span></h4>
        </a>
      </router-link>
      <router-link tag="li" :to="{name:'PendingHome', query: $route.query, params: { fileType: 'JINGLE' }}">
        <a>
          <h4><span class="text">Jingles</span></h4>
        </a>
      </router-link>
      <router-link tag="li" :to="{name:'PendingHome', query: $route.query, params: { fileType: 'PODCAST' }}">
        <a>
          <h4><span class="text">Podcasts</span></h4>
        </a>
      </router-link>
    </ul>
    <Pagination
        :pagination="pagination"
        :sizes="[100, 250, 500, 1000]"
        @page="handlePagination"
        @page-size="handlePageSize"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import EventBus from "@/eventbus";
import Pagination from "@/components/common/Pagination";
  export default {
    name: "PageSubMenuPending",
    components : { Pagination },
    watch: {
      '$route' () {
        this.$forceUpdate();
      }
    },
    computed:{
      ...mapState({
        currentStation:state => state.currentStation || {},
        pagination : state => state.Search.pagination
      }),
    },
    methods: {
      handlePagination (page) {
        EventBus.$emit("updatePages", page)
      },
      handlePageSize (pageSize) {
        this.$store.dispatch('Search/setPageSize', pageSize)
        EventBus.$emit("updatePages", 1)
      }
    }


  }
</script>
